import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import axios from "axios";
import styles from "./RoasteryPage.module.css";

// --- IMPORT IMAGES ---
import banner1 from "../assets/Roastery/banner-1.jpg";
import banner2 from "../assets/Roastery/banner-2.jpg";
import banner3 from "../assets/Roastery/banner-3.jpg";
import sourcingMain from "../assets/Roastery/sourcing-main.jpg";
import roastingMain from "../assets/Roastery/roasting-main.jpg";
import cupMain from "../assets/Roastery/cup-main.jpg";
import wholesale1 from "../assets/Roastery/wholesale-1.jpg";
import wholesale2 from "../assets/Roastery/wholesale-2.jpg";
import wholesale3 from "../assets/Roastery/wholesale-3.jpg";
import export1 from "../assets/Roastery/export-1.jpg";
import export2 from "../assets/Roastery/export-2.jpg";
import behindScenes1 from "../assets/Roastery/behind-scenes-1.jpg";
import recoJebena from "../assets/Roastery/reco-jebena.jpg";
import recoV60 from "../assets/Roastery/reco-v60.jpg";
import recoEspresso from "../assets/Roastery/reco-espresso.jpg";
import recoMokapot from "../assets/Roastery/reco-mokapot.jpg";

function RoasteryPage() {
  const [content, setContent] = useState(null);

  // 1. Fetch CMS Content
  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get("/api/pages/roastery")
      .then((res) => {
        if (res.data && res.data.textFields) {
          setContent(res.data.textFields);
        }
      })
      .catch((err) => console.log("Using default content"));
  }, []);

  // 2. Helper to get text safely
  const getText = (key, fallback) => {
    return content && content[key] ? content[key] : fallback;
  };

  return (
    <div className={styles.roasteryPage}>
      <Navbar />

      {/* HERO SECTION */}
      <section className={styles.roasteryHero}>
        <h1>{getText("heroTitle", "Inherited Energy")}</h1>
        <Link to="/products">
          <button className={styles.buyNowBtn}>Buy Now</button>
        </Link>
      </section>

      {/* INTRO COLUMNS */}
      <section className={styles.roasteryIntroColumns}>
        <div className={styles.introCol}>
          <img src={banner1} alt="Dukamo Coffee cup" />
          <h3>Dukamo Coffee</h3>
          <p>
            You can find Dukamo Roasted coffee At our coffee shop or order
            online
          </p>
        </div>
        <div className={styles.introCol}>
          <img src={banner3} alt="Dukamo Coffee bags" />
          <h3>Buncho Coffee</h3>
          <p>
            Buncho is a wholesale wing of our company. We roast for hotel,
            office, bank, café, restaurant, or specialty stores.
          </p>
        </div>
      </section>

      {/* FARM TO CUP SECTION */}
      <section className={styles.roasteryFarmToCup}>
        <h2>From Farm to Cup</h2>
        <div className={styles.farmToCupGrid}>
          <div className={styles.farmCard}>
            <img src={sourcingMain} alt="Sourcing coffee beans" />
            <h3>Sourcing</h3>
            <p style={{ whiteSpace: "pre-line" }}>
              {getText(
                "sourcingText",
                "We source our coffee directly from our own farms, partner farmers, and ethical traders, ensuring every bean is rooted in quality and sustainability. From farm to cup, each step of the journey is handled with meticulous care, down to the smallest detail, to bring you coffee that’s as exceptional as the story behind it."
              )}
            </p>
          </div>

          <div className={styles.farmCard}>
            <img src={roastingMain} alt="Roasting coffee beans" />
            <h3>Roasting</h3>
            <p style={{ whiteSpace: "pre-line" }}>
              {getText(
                "roastingText",
                "Our coffee beans are roasted by skilled professionals using state-of-the-art equipment and the latest roasting techniques. We offer a wide range of roasts, from light to dark, ensuring something for every palate. What sets us apart is our ability to customize roasts to match our customers' unique flavor profiles, delivering a personalized coffee experience like no other."
              )}
            </p>
          </div>

          <div className={styles.farmCard}>
            <img src={cupMain} alt="A cup of coffee" />
            <h3>Cup</h3>
            <p>
              Our skilled baristas craft each cup using a variety of methods,
              from pour-over to traditional Ethiopian jebena, ensuring rich and
              flavorful coffee every time. We take pride in offering a range of
              roasts.
            </p>
          </div>
        </div>

        {/* --- THIS QUOTE WILL BE CENTERED ON MOBILE --- */}
        <p className={styles.italicQuote}>
          "In every Ethiopian heart, there is a special place for coffee and the
          ceremony. However, not all Ethiopians have the knowledge about the
          fruit they love. A cup of coffee can tell a story of its origin and
          the flavors it has to offer."
        </p>
      </section>

      {/* WHOLESALE SECTION */}
      <section className={styles.roasteryWholesale}>
        <div className={styles.wholesaleHeader}>
          <h2>WholeSale</h2>
          <p style={{ whiteSpace: "pre-line" }}>
            {getText(
              "wholesaleText",
              "At Buncho Coffee, we are proud to partner with businesses by offering premium wholesale coffee services tailored to meet your unique needs. Whether you're a hotel, office, bank, café, restaurant, or specialty store, our roastery is equipped to deliver exceptional coffee solutions."
            )}
          </p>
        </div>

        <div className={styles.wholesaleGrid2}>
          <div className={styles.wholesaleCard}>
            <img src={behindScenes1} alt="Quality Coffee Sourcing" />
            <h3>Quality You Can Trust</h3>
            <p>
              Our coffee is ethically sourced, carefully processed, and
              meticulously inspected to maintain the highest standards. With
              Buncho Coffee, you can confidently serve fresh, flavorful coffee
              that delights your customers.
            </p>
          </div>
          <div className={styles.wholesaleCard}>
            <img src={wholesale3} alt="Dedicated Support Team" />
            <h3>Dedicated Support</h3>
            <p>
              Our team is here to help you create the ideal coffee program for
              your business. Whether it’s designing a custom blend or providing
              brewing recommendations, we work closely with you to ensure your
              coffee offerings stand out.
            </p>
          </div>
        </div>

        <div className={styles.wholesaleGrid3}>
          <div className={styles.wholesaleCard}>
            <img src={wholesale2} alt="Custom Coffee Roasting" />
            <h3>Custom Roasting</h3>
            <p>
              We understand that every business and customer has a distinct
              flavor preference. That’s why we provide custom roasting services,
              allowing you to choose the roast profile that best suits your
              brand or clientele. From light and fruity roasts to bold and rich
              profiles, we carefully craft each batch to perfection...
            </p>
          </div>
          <div className={styles.wholesaleCard}>
            <img src={export2} alt="Custom Coffee Grinding" />
            <h3>Custom Grinding</h3>
            <p>
              We offer custom grinding options to match your preferred brewing
              methods. Whether it’s coarse grind for French press, medium-fine
              for Jebena, or espresso-fine for rich shots, we ensure consistent
              quality with every grind.
            </p>
          </div>
          <div className={styles.wholesaleCard}>
            <img src={wholesale1} alt="Flexible Packaging" />
            <h3>Flexible Quantities & Packaging</h3>
            <p>
              We cater to orders of all sizes and offer flexible packaging
              options, ensuring you get the right amount of coffee delivered in
              the most convenient format.
            </p>
          </div>
        </div>

        <div className={styles.wholesaleContact}>
          <p>For Wholesale service call</p>
          <a href="tel:+251924222200">(+251)92-422-22-00</a>
        </div>
      </section>

      {/* EXPORT SECTION */}
      <section className={styles.roasteryExport}>
        <div className={styles.exportText}>
          <h2>Export</h2>
          <p style={{ whiteSpace: "pre-line" }}>
            {getText(
              "exportText",
              "We take pride in sharing Ethiopia’s rich coffee heritage with the world. Sourced from the finest coffee-growing regions, our beans are meticulously selected, ethically sourced, and expertly roasted to meet diverse global preferences. We export a variety of Ethiopian coffee, including specialty-grade, single-origin, and custom blends, ensuring quality and consistency in every shipment. We sell roasted whole beans or ground coffee, custom-packed for international markets. We work with businesses, roasters, and retailers to provide coffee under their brand."
            )}
          </p>

          <div className={styles.exportContact}>
            <p>To make orders or for more information</p>
            <p>Phone: (+251)91-098-5454 (Direct call or Whatsapp)</p>
            <p>Wechat ID: @Rudypooh</p>

            <p>
              Email:{" "}
              <a href="mailto:Bethlehem@dukamocoffee.com">
                Bethlehem@dukamocoffee.com
              </a>
            </p>
            <p>
              or{" "}
              <a href="mailto:info@bunchocoffee.com">info@bunchocoffee.com</a>
            </p>
          </div>
        </div>

        <div className={styles.exportImages}>
          <figure>
            <img src={export1} alt="Coffee drying beds" />
          </figure>
        </div>
      </section>

      {/* BEHIND THE SCENES SECTION */}
      <section className={styles.roasteryBehindScenes}>
        <div className={styles.behindScenesText}>
          <h2>Behind the Scene</h2>
          <p>
            Behind the scenes of our roasting process, a lot of care and
            expertise go into creating the perfect coffee. The beans are then
            carefully roasted to bring out their unique flavors, with each batch
            being monitored by our skilled roasters. The timing, temperature,
            and technique are all essential factors, as even the smallest change
            can impact the final taste. Roasting is a delicate balance between
            art and science, and we take pride in perfecting each batch.
          </p>
        </div>
        <div className={styles.behindScenesImages}>
          <figure>
            <img src={banner2} alt="Dukamo Coffee Art" />
            <figcaption>Roasting a 15kg batch</figcaption>
          </figure>
        </div>
      </section>

      {/* RECOMMENDATIONS SECTION */}
      <section className={styles.roasteryRecommendations}>
        <h2>Roasting, Grinding and Brewing Recommendations</h2>
        <p>
          Here's our recommendation for the common brewing practices. These
          recommendations help highlight the unique characteristics of each
          brewing method while ensuring the best flavor for every cup. Different
          people do it differently this is just our suggetion
        </p>
        <div className={styles.recoGrid}>
          <div className={styles.recoCard}>
            <img src={recoJebena} alt="Jebena" />
            <h3>Jebena</h3>
            <p>
              <strong>Roast Level:</strong> Medium to Medium-Dark. A slightly
              darker roast enhances the robust and earthy flavors preferred in
              traditional Ethiopian coffee ceremonies.
            </p>
            <p>
              <strong>Grind Size:</strong> Medium-Fine. This allows for a
              balanced extraction during the slower brewing process in a jebena.
            </p>
            <p>
              <strong>Brewing Tips:</strong> Allow the grounds to steep
              thoroughly for full flavor extraction. Serve unfiltered, allowing
              fine particles to settle naturally. Enhance with butter, sugar,
              salt, or traditional spices like cardamom or cinnamon, based on
              preference.
            </p>
          </div>
          <div className={styles.recoCard}>
            <img src={recoV60} alt="V60" />
            <h3>V60 (Pour-Over Coffee)</h3>
            <p>
              <strong>Roast Level:</strong> Light to Medium. Lighter roasts
              preserve delicate fruity and floral notes, perfect for showcasing
              single-origin beans.
            </p>
            <p>
              <strong>Grind Size:</strong> Medium-Fine (similar to table salt).
              This ensures proper water flow and balanced extraction.
            </p>
            <p>
              <strong>Brewing Tips:</strong> Use a 1:15 coffee-to-water ratio.
              Pour in slow, circular motions to saturate all the grounds evenly.
              Aim for a brewing time of 2-4 minutes for optimal flavor clarity.
            </p>
          </div>
          <div className={styles.recoCard}>
            <img src={recoEspresso} alt="Espresso" />
            <h3>Espresso</h3>
            <p>
              <strong>Roast Level:</strong> Medium-Dark to Dark. This roast
              level provides the crema, body, and intense flavor typical of
              espresso.
            </p>
            <p>
              <strong>Grind Size:</strong> Very Fine (similar to powdered
              sugar). The fine grind is crucial for proper pressure and
              extraction in an espresso machine.
            </p>
            <p>
              <strong>Brewing Tips:</strong> Use 18–20g of coffee for a double
              shot, with a brewing time of 25–30 seconds. Adjust grind size and
              tamping pressure to perfect the flow rate. Serve immediately for
              the freshest and boldest flavor.
            </p>
          </div>
          <div className={styles.recoCard}>
            <img src={recoMokapot} alt="Moka Pot" />
            <h3>Moka Pot</h3>
            <p>
              <strong>Roast Level:</strong> Medium-Dark to Dark. The moka pot
              emphasizes bold, rich, and chocolatey flavors best captured in
              darker roasts.
            </p>
            <p>
              <strong>Grind Size:</strong> Fine (slightly coarser than
              espresso). Prevents over-extraction while allowing the pressurized
              water to flow smoothly through the grounds.
            </p>
            <p>
              <strong>Brewing Tips:</strong> Fill the bottom chamber with hot
              water to reduce over-heating. Avoid packing the coffee too tightly
              in the filter basket. Remove from heat as soon as the coffee
              starts sputtering to avoid bitterness.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default RoasteryPage;
